export const environment = {
  production: true,
  // apiUrl: 'https://admin-api.dev.equidesk.io/api',
  apiUrl: 'http://localhost:3001/api',
};
